module.exports = __webpack_public_path__ + "media/addons/Discount-c2d2c0c8.svg";